module.exports = __webpack_public_path__ + "static/img/HK-apple.368a2b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HK-apple.png
// module id = +tiW
// module chunks = 3